export type CompanyAction = "management" | "default";
export type GroupAction =
  | "management"
  | "senior_operation"
  | "rescue_operation"
  | "operation";

export type Actions = {
  Company: CompanyAction;
  Group: GroupAction;
};

export type Action = string;
export type ScopeName = keyof Actions;

export interface Scope<
  R extends ScopeName = ScopeName,
  A extends Action & Actions[R] = Actions[R]
> {
  resource: R;
  resourceId: string;
  action: A;
}
export type Scopes<N extends ScopeName = ScopeName> = Scope<N>[];

export const equal = (a: Scope, b: Scope): boolean =>
  a.action === b.action &&
  a.resourceId === b.resourceId &&
  a.resource === b.resource;

export const check = (allowed: Scopes, scopes: Scopes): boolean => {
  // 同一の指定が含まれていればtrueを返す
  for (const a of allowed) {
    for (const s of scopes) {
      if (equal(a, s)) {
        return true;
      }
    }
  }
  return false;
};

export const toString = (
  allowed: Scopes,
  groupId: string
): "マネージャー" | "オペレーター" => {
  const groupManager: Scope<"Group"> = {
    resource: "Group",
    resourceId: groupId,
    action: "management"
  };
  return check(allowed, [groupManager]) ? "マネージャー" : "オペレーター";
};
